import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import ProgressBar from '../../ProgressBar/ProgressBar';
import styles from './ProfileCard.module.scss';
import { switchJobSeeking } from '../../../../actions/user';

function Avatar(props) {
  const { src, alt } = props;
  return (
    <div>
      {src ? (
        <img src={src} alt={alt} className={`${styles.profileCard__image__img}`} />
      ) : (
        <div className={styles.place_holder}>
          <AccountCircleIcon sx={{ fontSize: 105 }} />
        </div>
      )}
    </div>
  );
}

function ProfileCard(props) {
  const { userData } = props;

  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <div>
      <div className={`${styles.profileCard} mb-5`}>
        <div className={styles.profileCard__image}>
          <div className={`img-circle `}>
            <Avatar
              //  src="https://pbs.twimg.com/profile_images/1498813192163659776/5olP9GJC_400x400.jpg"
              // "src= fetch user ddata profile image url to display profile photo"
              alt="profile picture"
            />
          </div>

          {/* <EditIcon
            className={styles.profileCard__image__editIcon}
            //comented out untill option to change profile picture is available
          /> */}
        </div>
        <div className={styles.profileCard__text}>
          <div className={styles.profileCard__text__name}>
            {userData?.FirstName}, {userData?.LastName}
          </div>
          <div className={styles.profileCard__text__title}>{userData?.title}</div>
          <div className={styles.profileCard__text__location}>
            {`${userData?.City},`} {userData?.State ? `${userData?.State},` : ''} {userData?.Country}
          </div>
        </div>

        <div className={`${styles.profileCard__toggle} form-check form-switch`}>
          <input
            data-testid="switch"
            onClick={() => dispatch(switchJobSeeking(userData?.Id, !userData?.IsJobSeeking))}
            className={`form-check-input ${
              userData?.IsJobSeeking
                ? styles.profileCard__toggle__inputActive
                : styles.profileCard__toggle__inputInActive
            }`}
            type="checkbox"
            role="switch"
            id="flexSwitchCheckChecked"
            checked={userData?.IsJobSeeking}
            onChange={() => {}}
          />
          <label
            className={`form-check-label ${userData?.IsJobSeeking ? styles.labelActive : styles.labelInActive}`}
            htmlFor="flexSwitchCheckChecked"
          >
            {userData?.IsJobSeeking ? t('dashboard.profile.activelyseeking') : t('dashboard.profile.notseeking')}
          </label>
        </div>
      </div>
      {/* <ProgressBar
        message="Profile Strength"
        width="w-75"
      /> */}
      {/* not release 1 */}
    </div>
  );
}

export default ProfileCard;
